var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8215 6.06872L18.531 5.78984L17.8557 5.9516C15.3417 6.77961 12.6952 7.20009 9.992 7.20009C7.29775 7.20009 4.6575 6.77961 2.14375 5.9516L1.4695 5.78984L1.1785 6.06872C0.53 6.69057 0 7.92034 0 8.79994V16H2.5L3.16825 13.4346C7.7575 14.1846 12.4567 14.1462 16.831 13.4329L17.5 16H20V8.79994C20 7.92034 19.4695 6.69057 18.8215 6.06872ZM5.37925 10.9422C5.12475 11.2854 2.88225 11.2854 2.62775 10.9422C2.45775 10.7142 2.45775 9.52283 2.62775 9.29459C2.89575 8.93363 5.37925 9.68291 5.37925 10.119C5.37925 10.2563 5.4635 10.8282 5.37925 10.9422ZM17.373 10.9432C17.1182 11.2861 14.8755 11.2861 14.6215 10.9432C14.5367 10.8289 14.6215 10.2572 14.6215 10.1195C14.6215 9.68363 17.1045 8.93434 17.373 9.29531C17.5422 9.52355 17.5422 10.7149 17.373 10.9432Z",
    fill: "#8B857E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9449 3.19995L16.3604 1.51777C16.0699 0.682805 15.0829 0 14.1666 0H5.83313C4.91663 0 3.92938 0.682805 3.63988 1.51777L3.05588 3.19995H0.83313V4.39995L2.49988 4.80004C7.49813 6.46013 12.8644 6.33893 17.4999 4.80004L19.1666 4.39995V3.19995H16.9449Z",
    fill: "#8B857E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicles);
export default __webpack_public_path__ + "static/media/Vehicles.0b6b36c69e234a267c8d38a269999a8d.svg";
export { ForwardRef as ReactComponent };